module.exports = __webpack_public_path__ + "static/media/backgroundMC.4480e7ac.webp";